<mat-toolbar class="main-header">
  <div class="header-container w-100 d-flex align-items-center justify-content-between">
    <div class="header-block d-flex flex-column justify-content-center">
      <span class="page-title text-truncate">{{ pageTitle() | translate }}</span>
      <span class="page-subtitle text-truncate">{{
        'backoffice.shell.subtitle' | translate
      }}</span>
    </div>

    <div class="header-block actions-block d-flex align-items-center justify-content-end gap-3">
      @if (operatorFacade.operator(); as operator) {
        <div class="operator-block d-flex align-items-center gap-2">
          <av-avatar
            [name]="operator.initialsSeed"
            [photoUrl]="operatorFacade.photo()"
            size="sm"
          ></av-avatar>

          <span class="operator-identity d-flex flex-column align-items-start">
            <span class="operator-name text-truncate">{{ operatorFacade.displayName() }}</span>
            <span class="operator-role text-truncate">{{
              operatorFacade.systemRoleLabelKey() | translate
            }}</span>
          </span>
        </div>
      }

      <div class="actions-divider"></div>

      <button
        type="button"
        class="logout-btn d-flex align-items-center"
        [matTooltip]="'backoffice.shell.sign_out' | translate"
        [attr.aria-label]="'backoffice.shell.sign_out' | translate"
        (click)="logout()"
      >
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
